import { render, staticRenderFns } from "./NavigationBarMenuItem.vue?vue&type=template&id=85aef080&scoped=true&"
import script from "./NavigationBarMenuItem.vue?vue&type=script&lang=js&"
export * from "./NavigationBarMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./NavigationBarMenuItem.vue?vue&type=style&index=0&id=85aef080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85aef080",
  null
  
)

export default component.exports